import { Component, Input, OnInit } from '@angular/core';
import { AdminServiceService } from '../../service/admin-service.service';

@Component({
  selector: 'app-product-stats',
  templateUrl: './product-stats.component.html',
  styleUrls: ['./product-stats.component.scss'],
})
export class ProductStatsComponent implements OnInit {
  @Input() storeId = '';
  @Input() sizeLg = 3;
  public totalPages = 0;
  public products = [];
  public stores = [];
  private _actualPage = 1;
  public search = '';

  constructor(
    private adminSv: AdminServiceService
  ) { }

  ngOnInit() {
    this.getProducts();
  }

  async getStores(){
    try{
      if(!this.search){
        this.stores = [];
        return false;  
      }
      const res = await this.adminSv.getStores(this.search);
      this.stores = res;
    }catch(err){
      console.error(err);
    }
  }

  async getProducts(){
    const products = await this.adminSv.getStats(
      'indexProduct', 
      this._actualPage,
      '',
      '',
      this.storeId
    );
    this.products = products.data;
    this.totalPages = products.meta.last_page;
  }

  changePage(ev){
    this._actualPage = ev;
    this.getProducts();
  }

  async setStore(id){
    this.storeId = id;
    this.search = '';
    await this.getProducts();
  }

}
